import React, { Component, PropTypes } from 'react';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';
import Button from 'muicss/lib/react/button';
import { Link } from 'react-router/es';

export default class MenuEngineeringItems extends Component {
  static propTypes = {
    title: PropTypes.string,
    id: PropTypes.number,
    onItemClick: PropTypes.func,
    skey: PropTypes.string,
  };
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { id, title, onItemClick } = this.props;
    onItemClick(id, title, null);
  }
  render() {
    const { title, onItemClick, skey } = this.props;
    const keyIndex = title.toLowerCase().indexOf(skey.toLowerCase());
    let boldPrevTitle = title.substring(0, keyIndex);
    let boldTitle = title.substring(keyIndex, keyIndex + skey.length);
    let boldNextTitle = title.substring(keyIndex + skey.length);
    if (keyIndex < 0) {
      boldPrevTitle = null;
      boldTitle = null;
      boldNextTitle = title;
    }

    return (
      <div className='pointer search-item' onClick = { this.onClick }>
        <Link>{boldPrevTitle}<b>{boldTitle}</b>{boldNextTitle}</Link>
      </div>
    );
  }
}
